import React from 'react';
import { PortableText } from '@portabletext/react';

import {
	Typography,
	AccordionSummary,
	AccordionDetails,
	Accordion,
	Grid,
	Button,
	makeStyles,
	withStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles((theme) => ({
	question: {
		color: theme.workwaveBlue,
		fontWeight: 'bold',
	},
	answer: {
		color: '#5A7184',
		fontWeight: 500,
		// marginTop: '1rem',
		'& a': {
			color: theme.workwaveBlue,
		},
	},
	icon: {
		color: theme.workwaveBlue,
	},
}));

const StyledAccordion = withStyles((theme) => ({
	root: {
		border: `1px solid ${theme.borderLightGray}`,
		borderRadius: '10px',
		// padding: '1rem',
		marginBottom: '1rem',
		'&:hover': {
			cursor: 'pointer',
		},
		'&:not(:last-child)': {
			borderBottom: 0,
		},
		'&:before': {
			display: 'none',
		},
		'&$expanded': {
			margin: 'auto',
		},
	},
	expanded: {
		marginBottom: '1rem!important',
	},
}))(Accordion);

export const FAQ = ({ faq, index, expanded, setExpanded, faqRef }) => {
	const { question, _rawAnswer } = faq;

	const classes = useStyles();

	const handleChange = (index) => {
		setExpanded(index);
		faqRef.current?.scrollIntoView({
			behavior: 'smooth',
		});
	};

	return (
		<>
			<StyledAccordion
				expanded={expanded === index ? true : false}
				className={classes.border}
				elevation={4}
				onChange={() => handleChange(index)}>
				<AccordionSummary
					style={{ padding: '1rem' }}
					expandIcon={
						expanded === index ? (
							<RemoveIcon style={{ color: '#19305A' }} fontSize='large' />
						) : (
							<AddIcon style={{ color: '#19305A' }} fontSize='large' />
						)
					}>
					<Typography variant='h6' className={classes.question}>
						{question}
					</Typography>
				</AccordionSummary>
				<AccordionDetails style={{ padding: '0 1rem 1rem 1rem' }}>
					<Grid container direction='column' className={classes.answer}>
						<Typography variant='body1'>
							<PortableText
								value={_rawAnswer}
								components={{
									block: {
										normal: ({ children }) => (
											<p style={{ margin: '0 0 1rem 0' }}>{children}</p>
										),
									},
									list: {
										number: ({ children, value }) => {
											return (
												<ol type={value.level === 1 ? 1 : 'a'}>{children}</ol>
											);
										},
									},
									marks: {
										code: () => <hr style={{ margin: '1rem 0' }} />,
										buttonLink: (props) => {
											return (
												<a
													href={props.value.buttonSlug}
													target='_blank'
													rel='noreferrer'>
													<Button
														variant='contained'
														color='primary'
														style={{ margin: '-1rem 0 1rem 0' }}>
														{props.children[0]}
													</Button>
												</a>
											);
										},
										emailPhoneLink: (props) => {
											return (
												<a href={props.emailPhoneHref}>{props.children[0]}</a>
											);
										},
										link: (props) => {
											return (
												<a
													href={props.value.href}
													style={{ textDecoration: 'underline' }}
													target='_blank'
													rel='noreferrer'>
													{props.children[0]}
												</a>
											);
										},
									},
								}}
							/>
						</Typography>
					</Grid>
				</AccordionDetails>
			</StyledAccordion>
		</>
	);
};
